import { paths } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { FC, ReactNode } from "react";
import { useAuthContext } from "~auth/contexts/auth";
import { MangoLogoLoadingBackdrop } from "~ui-components/index";

export const AccountGuard: FC<{ children: ReactNode }> = ({ children }) => {
	const router = useWebRouter();
	const { isLoading, isAuthenticated, isTrialExpired, isAccountClosed } =
		useAuthContext();

	if (isLoading) return <MangoLogoLoadingBackdrop />;

	if (!isAuthenticated) {
		return children;
	}

	if (isTrialExpired || isAccountClosed) {
		void router.replace(
			paths.accountName.settings.editSubscription(router._query.accountName),
		);
		return <MangoLogoLoadingBackdrop />;
	}

	return children;
};
